import { render, staticRenderFns } from "./BoardCell.vue?vue&type=template&id=7c15a0e4"
import script from "./BoardCell.vue?vue&type=script&lang=js"
export * from "./BoardCell.vue?vue&type=script&lang=js"
import style0 from "./BoardCell.vue?vue&type=style&index=0&id=7c15a0e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports